
// NATIVE 


// INSTALLED 

// CUSTOM 
import { AxiosAdapter } from "../commons/adapters";


const http = new AxiosAdapter();




// export const generateReportControlTimeService = async() => {
   
//     try {
        
//         return await http.get<any>('/v1/registro-express-checkin'); 

//     } catch (error:any) {
        
//         if( error &&  !error.ok ){
            
//             return error;

//         }
//         console.log('getExpressCheckinService ',error);

//     }
// }




export const generateReportControlTimeService = async(dataReport:object, setPercentaje:any) => {
   
    try {
        
        return await http.postReport<any>('/v1/reports/report-control-time', dataReport, setPercentaje);
        //  return await http.postReport<any>('/v1/reports/report-control-time', dataReport, setPercentaje); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('createExpressCheckinService ',error);

    }
}



// export const getAreaDetailService = async(areaId:string) => {
   
//     try {

//         return await http.get<any>(`/v1/area/${areaId}`); 

//     } catch (error:any) {
        
//         if( error &&  !error.ok ){
            
//             return error;

//         }
//         console.log('getAreaDetailService ',error);

//     }
// }



export const getOneExpressCheckinService = async(codeExpressCheckinId:string) => {
   
    try {

        return await http.get<any>(`/v1/registro-express-checkin/${codeExpressCheckinId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getOneExpressCheckinService ',error);

    }
}


export const updateExpressCheckinService = async(codeExpressCheckin: object) => {
   
    try {

        return await http.put<any>(`/v1/registro-express-checkin`, codeExpressCheckin); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('updateExpressCheckinService ',error);

    }
}




export const desactiveExpressCheckinService = async(codeExpressCheckinId: string) => {
   
    try {

        return await http.delete<any>(`/v1/registro-express-checkin/${codeExpressCheckinId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('desactiveExpressCheckinService ',error);

    }
}



export const activeExpressCheckinService = async(codeExpressCheckinId: string) => {
   
    try {

        return await http.patch<any>(`/v1/registro-express-checkin/${codeExpressCheckinId}`); 

    } catch (error:any) {
        
        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('activeExpressCheckinService ',error);

    }
}





export const getCodeExpressCheckinByPaginateService = async(page:number) => {
   
    try {

        return await http.get<any>(`/v1/registro-express-checkin?page=${page}&take=10`); 

    } catch (error:any) {

        if( error &&  !error.ok ){
            
            return error;

        }
        console.log('getCodeExpressCheckinByPaginateService ',error)
    }
}